/**
 * @file All available illustrations and their mapping to actual files
 */

export type IllustrationName =
  | 'ATTACHMENT'
  | 'CONCIERGE'
  | 'INFO'
  | 'REQUEST'
  | 'REQUEST_ANSWERED'
  | 'REQUEST_UNANSWERED'
  | 'SEARCH'
  | 'TASK'
  | 'TOPIC';

export const NAMES: Record<IllustrationName, string> = {
  ATTACHMENT: 'attachment.png',
  CONCIERGE: 'concierge.png',
  INFO: 'info.png',
  REQUEST: 'request.png',
  REQUEST_ANSWERED: 'request_answered.png',
  REQUEST_UNANSWERED: 'request_unanswered.png',
  SEARCH: 'search.png',
  TASK: 'task.png',
  TOPIC: 'topic.png',
};
